export default __webpack_public_path__ + "static/how-to-start-a-fire-4fe81f5a92750284e69399e9fdab94e3.jpg";